// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__KQRdg","sidebar_header":"Sidebar_sidebar_header__JiSBa","sidebar_wrap":"Sidebar_sidebar_wrap__Qhyw2"};